import { render, staticRenderFns } from "./Item31PDFTranslate.vue?vue&type=template&id=6b0a33d5&"
import script from "./Item31PDFTranslate.vue?vue&type=script&lang=js&"
export * from "./Item31PDFTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
